import { useRef } from "react";
import { useBootstrapPopover } from "../../hooks/useBootstrapOverlay";

const MemberInfoButton = ({ member }) => {
  const linkRef = useRef(null);

  const popoverOptions = {
    ajax: true,
    container: "body",
    url: `/members/${member.id}/popup_show`,
  };

  // Attaches to this link only, rather than reloading every popover on the page.
  useBootstrapPopover(linkRef, [member.id]);

  return (
    <div className="ibox-tools">
      <a
        ref={linkRef}
        href={`/members/${member.id}`}
        data-bind="popover"
        data-options={JSON.stringify(popoverOptions)}
      >
        <i className="fa fa-question-circle"></i>
      </a>
    </div>
  );
};

export default MemberInfoButton;
